var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notification"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 2887",
    d: "M7.88966 3.222C7.88966 2.63269 8.12376 2.06751 8.54047 1.65081C8.95717 1.2341 9.52235 1 10.1117 1C10.701 1 11.2661 1.2341 11.6828 1.65081C12.0996 2.06751 12.3337 2.63269 12.3337 3.222C13.6096 3.82547 14.6973 4.76478 15.4802 5.93925C16.263 7.11372 16.7116 8.47908 16.7777 9.889V13.222C16.8613 13.9127 17.1059 14.5742 17.4918 15.1531C17.8778 15.732 18.3942 16.2122 18.9997 16.555H1.22266C1.82808 16.2122 2.34455 15.732 2.73049 15.1531C3.11643 14.5742 3.36105 13.9127 3.44466 13.222V9.889C3.51076 8.47908 3.95927 7.11372 4.74214 5.93925C5.525 4.76478 6.6137 3.82547 7.88966 3.222Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.2227 7C21.2227 9.76142 18.9841 12 16.2227 12C13.4612 12 11.2227 9.76142 11.2227 7C11.2227 4.23858 13.4612 2 16.2227 2C18.9841 2 21.2227 4.23858 21.2227 7Z",
    fill: "#5557C9",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 2888",
    d: "M6.77734 16.5566V17.6676C6.77734 18.5517 7.12855 19.3996 7.7537 20.0248C8.37886 20.6499 9.22674 21.0011 10.1108 21.0011C10.9949 21.0011 11.8428 20.6499 12.468 20.0248C13.0931 19.3996 13.4443 18.5517 13.4443 17.6676V16.5566",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/Bell-icon.f52025e0a82777591a9e77b692a4c08f.svg";
export { ForwardRef as ReactComponent };